// extracted by mini-css-extract-plugin
export default {"filter":"VoiceRecording_filter__bogwG","cards":"VoiceRecording_cards__7HzUO","toggles-container":"VoiceRecording_toggles-container__dUpyQ"};